export default __webpack_public_path__ + "static/media/google_calendar_logo.ef7bc483.png";